module.exports = __webpack_public_path__ + "static/img/przybornik_gumka.d11889d5.png";